export default __webpack_public_path__ + "static/media/köide-25-26.fca11790.png";